// 获取方程式详情数据，传入一个方程式数据，获取其绑定的每一个数据

/*
    引入http请求，必须包含以下几个请求方法
    object.detail、object.detail_list
    tuwen.detail
    phamula.detail
    user.public_profile
*/
import * as http from '@/http/index.js'

// 自定义store
const store = {
	state: {
		/**** 缓存用户、图文、对象、方程式数据 ****/
		userData: Object.create(null),
		tuwenData: Object.create(null),
		objectData: Object.create(null),
		phamulaData: Object.create(null)
	},
	dispatch: async function(path = '', dataId = '') {
		const [type, mode] = path.split('/').filter(Boolean);
		if (path === '' || type === '' || mode === '' || dataId === '') {
			throw 'param error';
		}
		// 获取对象列表信息
		if (path === 'object/detailList') {
			const result = await http.object.detail_list(dataId);
			if (result === 'success' && Array.isArray(result.data)) {
				for (let object of result.data) {
					let object_id = object.object_id;
					objectData[object_id] = objectData[object_id] || Object.create(null);
					objectData[object_id] = Object.assign(objectData[object_id], object);
				}
			}
			return result;
		}
		// 获取图片、音频、视频信息
		if (type === 'file') {
			if (mode === 'detail') {}
			if (mode === 'find') {}
		}
		// 获取用户信息
		if (type === 'user') {
			if (mode === 'detail') {
				const result = await http.user.public_profile(dataId);
				if (result.status === 'success' && result.data) {
					this.state.userData[dataId] = this.state.userData[dataId] || Object.create(null);
					this.state.userData[dataId] = Object.assign(this.state.userData[dataId], result.data);
					if (Array.isArray(result.data.public_object_list)) {
						for (let object of result.data.public_object_list) {
							let object_id = object.object_id;
							objectData[object_id] = objectData[object_id] || Object.create(null);
							objectData[object_id] = Object.assign(objectData[object_id], object);
						}
					}
				}
				return result;
			}
			if (mode === 'find') {
				if (this.state.userData[dataId]) {
					return this.state.userData[dataId];
				}
				const result = await this.dispatch('user/detail', dataId);
				if (result.status === 'success' && result.data) {
					return result.data;
				}
				return null;
			}
		}
		// 获取图文信息
		if (type === 'tuwen') {
			if (mode === 'detail') {
				const result = await http.tuwen.detail(dataId);
				if (result.status === 'success' && result.data) {
					this.state.tuwenData[dataId] = this.state.tuwenData[dataId] || Object.create(null);
					this.state.tuwenData[dataId] = Object.assign(this.state.tuwenData[dataId], result.data);
				}
				return result;
			}
			if (mode === 'find') {
				if (this.state.tuwenData[dataId]) {
					return this.state.tuwenData[dataId];
				}
				const result = await this.dispatch('tuwen/detail', dataId);
				if (result.status === 'success' && result.data) {
					return result.data;
				}
				return null;
			}
		}
		// 获取对象信息
		if (type === 'object') {
			if (mode === 'detail') {
				const result = {
					status: 'error',
					data: null
				};
				const result_1 = await http.object.detail(dataId);
				if (result_1.status === 'success' && result_1.data) {
				    result.data = result_1.data;
				    result.status = 'success';
				}
				const result_2 = await this.dispatch('object/detailList', dataId);
				if (result_2.status === 'success' && result_2.data && result_2.data.length) {
				    result.data = result.data ? Object.assign(result.data, result_2.data[0]) : result_2.data[0];
				    result.status = 'success';
				}
				if (result.status === 'success' && result.data) {
					this.state.objectData[dataId] = this.state.objectData[dataId] || Object.create(null);
					this.state.objectData[dataId] = Object.assign(this.state.objectData[dataId], result.data);
				}
				return result;
			}
			if (mode === 'find') {
				if (this.state.objectData[dataId]) {
					return this.state.objectData[dataId];
				}
				const result = await this.dispatch('object/detail', dataId);
				if (result.status === 'success' && result.data) {
					return result.data;
				}
				return null;
			}
		}
		// 获取方程式信息
		if (type === 'phamula') {
			if (mode === 'detail') {
				const result = await http.phamula.detail(dataId);
				if (result.status === 'success' && result.data) {
					this.state.phamulaData[dataId] = this.state.phamulaData[dataId] || Object.create(null);
					this.state.phamulaData[dataId] = Object.assign(this.state.phamulaData[dataId], result.data);
				}
				return result;
			}
			if (mode === 'find') {
				if (this.state.phamulaData[dataId]) {
					return this.state.phamulaData[dataId];
				}
				const result = await this.dispatch('phamula/detail', dataId);
				if (result.status === 'success' && result.data) {
					return result.data;
				}
				return null;
			}
		}
		if (mode === 'detail') {
			return {
				status: 'error',
				data: null
			};
		}
		if (mode === 'find') {
			return null;
		}
	}
};

// 获取数据优先从本地缓存中来
const get_data_from_cache = true;

// 绑定的对象扩展的数据(user目前只在phamula上绑定)
const default_bind_data_key = 'user,audio,video,tuwen,object,phamula';

const handler = {
	isJson: function(data) {
		// 是否是JSON数据
		if (this.dataType(data, 'string')) {
			try {
				return this.dataType(JSON.parse(data), 'array, object');
			} catch(error) {
				return false;
			}
		}
		return false;
	},
	dataType: function(data, type = '') {
		const _type = Object.prototype.toString.apply(data).slice(8, -1).toLowerCase();
		return type ? type.indexOf(_type) > -1 : _type;
	},
	isDataId: function(id) {
		// 验证是否是大于0的正整数
		return /^[1-9]\d*$/.test(id);
	},
	isDataType: function(type) {
		// 验证是否是0和整数(正整数/负整数)
		if (typeof type === 'string' && type && isNaN(type) === false) {
			type = Number(type);
		}
		return typeof type === 'number' ? (type % 1 === 0) : false;
	},
	isPhamulaType: function(type) {
		// 是否是标准的方程式类型(大于等于-1的整数，包括0)
		return Boolean(['-1', -1].indexOf(type) > -1 || this.isDataId(type));
	}
};

function treeToArray(json = {}, childrenKey = 'su') {
	// 树结构json转一维数组array
	const stack = [{
		data: json,
		layer: 1,
		index: 0,
		parentIndex: -1
	}];
	let index = 0;
	// 将树结构扁平化
	while (stack[index]) {
		let { data: { [ childrenKey ]: children }, layer: curLayer, index: parentIndex } = stack[index];
		if (Array.isArray(children)) {
			for (let i = 0, length = children.length; i < length; i++) {
				stack.push({
					data: children[i],
					layer: curLayer + 1,
					index: i,
					parentIndex
				});
			}
		}
		index += 1;
	}
	return stack;
}

function completionData(data = {}) {
	// 父节点补全完善 rt su edd
	for (let key of ['rt', 'su', 'edd']) {
		if (key in data) {
			data['rt'] = data['rt'] || '';
			data['su'] = data['su'] || [];
			data['edd'] = data['edd'] || '';
			break;
		}
	}
	// 子节点补全完善 tg ed
	for (let key of ['tg', 'ed']) {
		if (key in data) {
			data['tg'] = data['tg'] || '';
			data['ed'] = data['ed'] || '';
			break;
		}
	}
	return data;
}

function addEditShowList(showList = [], data = {}, layer, index, parentIndex, childrenKey = 'su') {
	if (handler.dataType(showList, 'array') && handler.dataType(data, 'object')) {
		const newData = JSON.parse(JSON.stringify(data));
		if (layer === 2) {
			const isEdit = handler.dataType(showList[index], 'object');
			isEdit ? (showList[index] = Object.assign(showList[index], newData)) : showList.push(newData);
			// const isParent = handler.dataType(data[childrenKey], 'array');
			// isEdit ? (showList[index] = Object.assign(showList[index], isParent ? { ...newData, [childrenKey]: [] } : newData)) : showList.push(isParent ? { ...newData, [childrenKey]: [] } : newData);
		}
		if (layer === 3) {
			const isEdit = handler.dataType(showList[parentIndex][childrenKey][index], 'object');
			isEdit ? (showList[parentIndex][childrenKey][index] = Object.assign(showList[parentIndex][childrenKey][index], newData)) : showList[parentIndex][childrenKey].push(newData);
		}
	}
	return showList;
}

async function getData(type = '', value = '', fromLocal = get_data_from_cache, defaultData = Object.create(null)) {
	/*
		获取方程式、对象、图文、用户、图片、音频、视频数据
		type: phamula、object、tuwen、user、file
		value: phamula_id、object_id、tuwen_id、user_id、url
		fromLocal: true(默认从本地查找，如果没有再从http获取)，false(从http获取)
		defaultData: {}
	*/
	let data = null;
	let result = null;
	let status = 'error';
	if (['phamula', 'object', 'tuwen', 'user', 'file'].indexOf(type) > -1 && value) {
		if ((type === 'file' && handler.dataType(value, 'string')) || (type !== 'file' && handler.isDataId(value))) {
			// find方法会先从store本地查找数据，找到直接返回，否则去http请求数据(要么返回成功的数据要么返回null)
			// detail方法会直接去http[file/detail不同]请求数据(返回的数据格式为：{ status, data })
			result = await store.dispatch(type + (fromLocal ? '/find' : '/detail'), value);
			result = fromLocal ? result : (result.status === 'success' ? result.data : null);
			result = handler.dataType(result, 'object') ? result : null;
		}
	}
	if (result) {
		status = 'success';
		data = JSON.parse(JSON.stringify(result));
		if (handler.dataType(defaultData, 'object') && Object.keys(defaultData).length && Object.keys(result).length) {
			for (let [key, value] of Object.entries(defaultData)) {
				defaultData[key] = result[key] || value;
			}
			data = JSON.parse(JSON.stringify(defaultData));
		}
	}
	return {
		status,
		data
	};
}

async function runCallBack(callback, data, ...args) {
	if (handler.dataType(callback, 'function')) {
		const result = await callback(data, ...args);
		if (handler.dataType(result, 'undefined') === false) {
			return result;
		}
	}
	return data;
}

export function isObjectBound(data = {}) {
	// 是否已经绑定了对象数据
	return handler.dataType(data, 'object') && handler.dataType(data['_object_data'], 'object') && handler.isDataId(data['_object_data'].object_id);
}

export function judgeVariousData(data = {}, type = '', value) {
	// 判断是什么数据(用户、图文、对象、方程式、方程式树结构)
    if (data && type && handler.dataType(data, 'object')) {
        // 判断是否是用户数据(user.public_profile接口没有user_id这个字段)
        if (type === 'user') {
            if (handler.isDataId(data['user_id']) && (['email', 'public_object_list'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是图文数据
        if (type === 'tuwen') {
            if (handler.isDataId(data['tuwen_id']) && (['title', 'content'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是对象数据
        if (type === 'object') {
            if (handler.isDataId(data['object_id']) && (['name', 'photo'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是方程式数据 or 判断是否是某个类型的方程式 or 判断是否是方程式的树结构数据
		if (['phamula', 'phamula_type', 'phamula_tree'].indexOf(type) > -1) {
			if (handler.isDataId(data['phamula_id']) && handler.dataType(data['obj_relation_json'], 'object')) {
			    if (type === 'phamula') {
					return true;
				}
				if (handler.isPhamulaType(data.obj_relation_json['type']) && handler.dataType(data.obj_relation_json['jsonStr'], 'object')) {
					if (type === 'phamula_type' && String(data.obj_relation_json['type']) === String(value)) {
						return true;
					}
					if (type === 'phamula_tree') {
						return true;
					}
				}
			}
        }
    }
    return false;
}

export async function getObjectBindData(object_id = '', fromLocal = get_data_from_cache, bindDataKey = default_bind_data_key) {
	// 获取对象绑定的数据(异步函数)
	const result = Object.create(null),
		  needBindObject = bindDataKey.indexOf('object')  > -1 ||
						   bindDataKey.indexOf('audio')   > -1 ||
						   bindDataKey.indexOf('video')   > -1 ||
						   bindDataKey.indexOf('tuwen')   > -1 ||
						   bindDataKey.indexOf('phamula') > -1;
	// 获取对象数据
	if (needBindObject) {
		result['_object_data'] = Object.create(null);
		if (handler.isDataId(object_id)) {
			let { status, data } = await getData('object', object_id, fromLocal);
			(status === 'success') && (result['_object_data'] = data);
		}
		// 获取名称
		result['_name'] = result['_object_data'].name || '';
		// 获取头像
		result['_photo'] = result['_object_data'].photo || '';
	}
	// 获取音频时长
	if (bindDataKey.indexOf('audio') > -1) {
		result['_audio'] = '';
		result['_audio_duration'] = 0;
		let url = result['_object_data'].audio_url;
		if (url && handler.dataType(url, 'string')) {
			let { status, data } = await getData('file', url, fromLocal);
			if (status === 'success' && data.type === 'audio') {
				result['_audio'] = url || result['_audio'];
				result['_audio_duration'] = data.duration || result['_audio_duration'];
			}
		}
	}
	// 获取视频时长(小程序端无法获取时长等信息)
	if (bindDataKey.indexOf('video') > -1) {
		result['_video'] = '';
		result['_video_width'] = 0;
		result['_video_height'] = 0;
		result['_video_duration'] = 0;
		let url = result['_object_data'].url;
		if (url && handler.dataType(url, 'string')) {
			let { status, data } = await getData('file', url, fromLocal);
			if (status === 'success' && data.type === 'video') {
				result['_video'] = url || result['_video'];
				result['_video_width'] = data.width || result['_video_width'];
				result['_video_height'] = data.height || result['_video_height'];
				result['_video_duration'] = data.duration || result['_video_duration'];
			}
		}
	}
	// 获取图文数据
	if (bindDataKey.indexOf('tuwen') > -1) {
		result['_tuwen_data'] = Object.create(null);
		if (handler.isDataId(result['_object_data'].tuwen_id)) {
			let { status, data } = await getData('tuwen', result['_object_data'].tuwen_id, fromLocal);
			(status === 'success') && (result['_tuwen_data'] = data);
		}
	}
	// 获取方程式数据
	if (bindDataKey.indexOf('phamula') > -1) {
		result['_phamula_data'] = Object.create(null);
		if (handler.isDataId(result['_object_data'].phamula_id)) {
			let { status, data } = await getData('phamula', result['_object_data'].phamula_id, fromLocal);
			(status === 'success') && (result['_phamula_data'] = data);
		}
	}
	// 获取其他数据...
	return result;
}

export async function getPhamulaDetail(phamula = {}, callback = null, childrenKey = 'su') {
	if (handler.dataType(phamula, 'object') === false) {
		return phamula;
	}
	if (handler.dataType(phamula['obj_relation_json'], 'object') === false) {
		return phamula;
	}
	if (handler.dataType(phamula.obj_relation_json['jsonStr'], 'object') === false) {
		return phamula;
	}
	const json = JSON.parse(JSON.stringify(phamula.obj_relation_json['jsonStr']));
	const list = treeToArray(json, childrenKey).filter(item => item.layer <= 3); // 只处理最多2层
	const total = list.length - 1; // 第一项为根元素
	const maxLayer = list[total].layer;
	let showList = [];
	// console.log('json', JSON.parse(JSON.stringify(json)))
	// console.log('list', JSON.parse(JSON.stringify(list)))
	// console.log(maxLayer, total)
	for (let i = 1, length = total + 1; i < length; i++) {
		let { data, layer, index, parentIndex } = list[i];
		// 补全字段
		data = completionData(data);
		// 添加单项
		showList = addEditShowList(showList, data, layer, index, parentIndex, childrenKey);
		// 获取处理前的参数配置
		let { object_id, fromLocal, bindDataKey } = await runCallBack(callback, data, showList, 'before', i - 1, total, layer, index, parentIndex);
		// 如果存在绑定数据才进一步去判断要不要绑定数据
		if (object_id && bindDataKey && handler.isDataId(object_id)) {
			let bind = await getObjectBindData(object_id, fromLocal, bindDataKey);
			data = Object.assign(data, bind);
			// 修改单项
			showList = addEditShowList(showList, data, layer, index, parentIndex, childrenKey);
		}
		// 处理之后可再次处理
		data = await runCallBack(callback, data, showList, 'after', i - 1, total, layer, index, parentIndex);
		// 修改单项
		showList = addEditShowList(showList, data, layer, index, parentIndex, childrenKey);
	}
	json['su'] = showList;
	phamula.obj_relation_json['jsonStr'] = json;
	return phamula;
}